@if (loginService.IsLoggedIn()) {
  <nav class="navbar is-primary is-fixed-top" role="navigation" aria-label="main navigation"
    >
    @if (ShowBanner) {
      <div class="environment-banner">
        {{BannerText}}
      </div>
    }
    <div class="navbar-brand">
      <a class="navbar-item logo-container pt-0 pb-0 pl-6 pr-6" href="/">
        <img class="logo mr-5 ml-5" src="/assets/images/Frogparking-Logo-White.png" style="max-height: 50px" />
      </a>
    </div>
    <div id="menuToggle" class="is-hidden-desktop">
      <input id="chkToggle" type="checkbox" class="is-hidden-desktop" />
      <span aria-hidden="true" class="burger is-hidden-desktop"></span>
      <span aria-hidden="true" class="burger is-hidden-desktop"></span>
      <span aria-hidden="true" class="burger is-hidden-desktop"></span>
      <ul id="menu" class="is-hidden-desktop  is-scroll">
        @for (i of TopMenuItems; track i) {
          <div [ngStyle]="{'opacity' : i.Enabled ? 1 : 0.4, 'pointer-events': i.Enabled ? 'auto' : 'none' }">
            <div class="main-menu-item">{{i.Path}}</div>
            @for (j of GetSubMenu(i.Path); track j) {
              <div>
                <p class="sub-menu-item">{{j.Text}}</p>
                <ul class="menu-list">
                  @for (z of j.Children; track z) {
                    <li>
                      <a onclick='document.getElementById("chkToggle").checked = false;'
                      [routerLink]="z.Route">{{z.Text}}</a>
                    </li>
                  }
                </ul>
              </div>
            }
          </div>
        }
        <div>
          <ul class="menu-list">
            <hr>
              <li>
                <a routerLink="settings" class="nav-icon" onclick='document.getElementById("chkToggle").checked = false;'>
                  <span class="fa fa-cog"></span> Settings
                </a>
              </li>
              <li>
                <a routerLink="operatorconsole" class="nav-icon" onclick='document.getElementById("chkToggle").checked = false;'>
                  <span class="fa fa-terminal"></span> Operator Console
                </a>
              </li>
              <hr>
                <li>
                  @if (loginService.IsLoggedIn()) {
                    <a style="pointer-events: none;" [ngStyle]="{'color': 'lightgray'}" routerLink="account"><i class="fa fa-user"></i> &nbsp;{{loginService.LoggedInName()}} signed into {{CurrentOrganizationName}}</a>
                  }
                </li>
                <li>
                  @if (loginService.IsLoggedIn()) {
                    <div class="navbar-menu navbar-item has-dropdown"
                      [ngClass]="{ 'is-active' : ShowOrganizationsDropdown }">
                      <a class="navbar-link" (click)="ShowOrganizationsDropdown = !ShowOrganizationsDropdown">
                        <div style="min-width: 10em; color: green;"><span class="fa fa-shuffle"></span> Switch Organization</div>
                      </a>
                      @if (ShowOrganizationsDropdown) {
                        <div class="navbar-dropdown" (click)="ShowOrganizationsDropdown = false">
                          <div style="max-height:20em; overflow: auto;">
                            <div class="navbar-item">
                              <input
                                class="input is-small"
                                type="text"
                                        style="width: 100%;
                                        position: relative;
                                        opacity: 1;"
                                placeholder="Search organizations..."
                                [(ngModel)]="orgSearchText"
                                (click)="$event.stopPropagation()"
                                (input)="$event.stopPropagation()">
                              </div>
                              @for (o of filteredOrganizations; track o) {
                                <a class="navbar-item" style="white-space: normal; color: black;" [routerLink]="'switchorganizations/' + o.Id">
                                  {{o.Name}}
                                </a>
                              }
                            </div>
                            <hr class="navbar-divider">
                          </div>
                        }
                      </div>
                    }
                  </li>
                  <li>
                    <a (click)="LogOut()" class="nav-icon">
                      <span class="fa fa-right-from-bracket"></span> Log Out
                    </a>
                  </li>
                  <hr>
                  </ul>
                </div>
              </ul>
            </div>
            <div id="navbarTop" class="navbar-menu">
              @if (TopMenuItems.length > 0) {
                <div class="navbar-start">
                  @for (i of TopMenuItems; track i) {
                    <a class="navbar-item" [routerLink]="i.Route" [ngStyle]="{'opacity' : i.Enabled ? 1 : 0.4, 'pointer-events': i.Enabled ? 'auto' : 'none' }">{{i.Text}}</a>
                  }
                  <a class="navbar-item" [routerLink]="'settings'" [ngStyle]="{'opacity' : 1, 'pointer-events': 'auto'}"><i class="fa fa-cog" style="margin-right:10px; "></i>Settings</a>
                </div>
              }
            </div>
            <div class="navbar-menu">
              <div class="navbar-end">
                @if (loginService.IsLoggedIn()) {
                  <div class="navbar-item"  style="padding-left:0px !important; padding-right:0px !important;" [ngClass]="{ 'is-active' : ShowAlertsDropdown }"
                    (click)="ShowAlertsDropdown = !ShowAlertsDropdown">
                    <div class="fa fa-bell"></div>@if (UnresolvedAlertCount != null && UnresolvedAlertCount > 0) {
                    <span class="tag is-rounded is-small"
                    [ngClass]="{'alert-count' : UnresolvedAlertCount != null && UnresolvedAlertCount > 0}">{{UnresolvedAlertCount}}</span>
                  }
                  <div class="navbar-dropdown" style="max-width:20em;" (click)="ShowAlertsDropdown = false">
                    @for (o of Alerts; track o) {
                      <div class="navbar-item card" style="display: block; cursor: pointer;"
                        [ngClass]="{'resolved' : o.ResolvedAt != null }" >
                        <div class="card-content">
                          <div class="content">
                            <span (click)="ViewEntity(o)">
                              <h6 style="display: inline-block;">{{o.Title}}: </h6>
                              <p class="card-timestamp" style="display: inline-block; padding-left:5px;">
                              {{o.TimeTriggered}}</p>
                              <br>
                                <p class="card-description" style="max-width: 12em; white-space:normal; display:inline-block; word-wrap: break-word;" >
                                {{o.Description}}</p>
                              </span>
                              @if (o.ResolvedAt == null) {
                                <button
                                    type="button" style="display: inline-block; left:10px;
                                border-radius: 17px;" class="button is-primary is-small" (click)="ResolveAlert(o)">Mark
                                Resolved</button>
                              }
                              <br>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  }
                  @if (ShowOperatorConsole) {
                    <div class="navbar-item">
                      <a routerLink="operatorconsole" class="nav-icon">
                        <span class="fa fa-terminal" style="padding-left:0px !important; padding-right:10px !important;"></span>
                      </a>
                    </div>
                  }
                  <div class="navbar-item" style="color:lightgray;">
                    |
                  </div>
                  <div class="navbar-item myaccount">
                    @if (loginService.IsLoggedIn()) {
                      <a [ngStyle]="{'color': 'inherit'}" routerLink="account"><i class="fa fa-user" style="margin-right:10px;"></i> &nbsp;{{loginService.LoggedInName()}}</a>
                    }
                    @if (!loginService.IsLoggedIn()) {
                      <div>
                        (not logged in)
                      </div>
                    }
                  </div>
                  @if (loginService.IsLoggedIn()) {
                    <div class="navbar-item has-dropdown mr-3"
                      [ngClass]="{ 'is-active' : ShowOrganizationsDropdown }">
                      <a class="navbar-link input select orgselector" [ngClass]="{ 'is-active' : ShowOrganizationsDropdown }" style="margin-top: 10px; height: 2em;" (click)="ShowOrganizationsDropdown = !ShowOrganizationsDropdown">
                        <div style="min-width: 10em;">{{CurrentOrganizationName}}</div>
                      </a>
                      <div class="navbar-dropdown" (click)="ShowOrganizationsDropdown = false">
                        <div style="max-height:20em; overflow: auto;">
                          <div class="navbar-item">
                            <input
                              class="input is-small"
                              type="text"
                              placeholder="Search organizations..."
                              [(ngModel)]="orgSearchText"
                              (click)="$event.stopPropagation()"
                              (input)="$event.stopPropagation()">
                            </div>
                            @for (o of filteredOrganizations; track o) {
                              <a class="navbar-item" style="white-space: normal;" [routerLink]="'switchorganizations/' + o.Id">
                                {{o.Name}}
                              </a>
                            }
                          </div>
                          <hr class="navbar-divider">
                          <div class="navbar-item" >
                            <button type="button" class="button is-primary is-small is-outlined is-fullwidth"
                            (click)="LogOut()">Log Out</button>
                          </div>
                          <!-- <div class="navbar-item" >
                          <button type="button" class="button is-primary is-small is-outlined is-fullwidth" (click)="loginService.DebugBreakAuthToken()">*break session*</button>
                        </div> -->
                      </div>
                    </div>
                  }
                </div>
              </div>
            </nav>
          }